import axios from 'axios';
import config from 'config.js';

// Constants
const CLEAR_USERS = 'users/CLEAR_USERS';
const CLEAR_USER = 'users/CLEAR_USER';

const GET_USERS_REQUEST = 'users/GET_USERS_REQUEST';
const GET_USERS_SUCCESS = 'users/GET_USERS_SUCCESS';
const GET_USERS_FAILURE = 'users/GET_USERS_FAILURE';

const GET_MAILS_REQUEST = 'users/GET_MAILS_REQUEST';
const GET_MAILS_SUCCESS = 'users/GET_MAILS_SUCCESS';
const GET_MAILS_FAILURE = 'users/GET_MAILS_FAILURE';

const UPDATE_USER_REQUEST = 'users/UPDATE_USER_REQUEST';
const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
const UPDATE_USER_FAILURE = 'users/UPDATE_USER_FAILURE';

const EXTEND_USER_TRIAL_REQUEST = 'users/EXTEND_USER_TRIAL_REQUEST';
const EXTEND_USER_TRIAL_SUCCESS = 'users/EXTEND_USER_TRIAL_SUCCESS';
const EXTEND_USER_TRIAL_FAILURE = 'users/EXTEND_USER_TRIAL_FAILURE';

const GET_USER_REQUEST = 'users/GET_USER_REQUEST';
const GET_USER_SUCCESS = 'users/GET_USER_SUCCESS';
const GET_USER_FAILURE = 'users/GET_USER_FAILURE';

const DELETE_USER_REQUEST = 'users/DELETE_USER_REQUEST';
const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
const DELETE_USER_FAILURE = 'users/DELETE_USER_FAILURE';

const GET_ACTIVE_REQUEST = 'users/GET_ACTIVE_REQUEST';
const GET_ACTIVE_SUCCESS = 'users/GET_ACTIVE_SUCCESS';
const GET_ACTIVE_FAILURE = 'users/GET_ACTIVE_FAILURE';

const GET_LTD_USERS_REQUEST = 'users/GET_LTD_USERS_REQUEST';
const GET_LTD_USERS_SUCCESS = 'users/GET_LTD_USERS_SUCCESS';
const GET_LTD_USERS_FAILURE = 'users/GET_LTD_USERS_FAILURE';

const GET_LTD_USERS_INVOICES_REQUEST = 'users/GET_LTD_USERS_INVOICES_REQUEST';
const GET_LTD_USERS_INVOICES_SUCCESS = 'users/GET_LTD_USERS_INVOICES_SUCCESS';
const GET_LTD_USERS_INVOICES_FAILURE = 'users/GET_LTD_USERS_INVOICES_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    }
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  users: null,
  user: null,
  mails: null,
  active: null,
  ltdUsers: null,
  ltdOrders: [],

  extendUserTrial: { ...endpoitInitialStatus },
  getUsers: { ...endpoitInitialStatus },
  updateUser: { ...endpoitInitialStatus },
  getUser: { ...endpoitInitialStatus },
  getMails: { ...endpoitInitialStatus },
  deleteUser: { ...endpoitInitialStatus },
  getActive: { ...endpoitInitialStatus },
  getLtdUsers: { ...endpoitInitialStatus },
  getLtdUsersInvoices: { ...endpoitInitialStatus }
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  if (action.type === CLEAR_USERS) {
    state.users = null;

    return { ...state };
  }

  if (action.type === CLEAR_USER) {
    state.user = null;

    return { ...state };
  }

  if (action.type === GET_ACTIVE_REQUEST) {
    state.getActive = getEndpointStatus('request');
    state.mails = null;

    return { ...state };
  }

  if (action.type === GET_ACTIVE_SUCCESS) {
    state.getActive = getEndpointStatus('success');
    state.active = [...action.payload.users];

    return { ...state };
  }

  if (action.type === GET_ACTIVE_FAILURE) {
    state.getActive = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_MAILS_REQUEST) {
    state.getMails = getEndpointStatus('request');
    state.mails = null;

    return { ...state };
  }

  if (action.type === GET_MAILS_SUCCESS) {
    state.getMails = getEndpointStatus('success');
    state.mails = [...action.payload.mails];

    return { ...state };
  }

  if (action.type === GET_MAILS_FAILURE) {
    state.getMails = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_USERS_REQUEST) {
    state.getUsers = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_USERS_SUCCESS) {
    state.getUsers = getEndpointStatus('success');
    state.users = [...action.payload];

    return { ...state };
  }

  if (action.type === GET_USERS_FAILURE) {
    state.getUsers = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_USER_REQUEST) {
    state.getUser = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_USER_SUCCESS) {
    state.getUser = getEndpointStatus('success');
    state.user = { ...action.payload };

    return { ...state };
  }

  if (action.type === GET_USER_FAILURE) {
    state.getUser = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === DELETE_USER_REQUEST) {
    state.deleteUser = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === DELETE_USER_SUCCESS) {
    state.deleteUser = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === DELETE_USER_FAILURE) {
    state.deleteUser = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === UPDATE_USER_REQUEST) {
    state.updateUser = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === EXTEND_USER_TRIAL_REQUEST) {
    state.extendUserTrial = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === EXTEND_USER_TRIAL_SUCCESS) {
    state.extendUserTrial = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === EXTEND_USER_TRIAL_FAILURE) {
    state.updateUser = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === UPDATE_USER_SUCCESS) {
    state.updateUser = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === UPDATE_USER_FAILURE) {
    state.updateUser = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_LTD_USERS_REQUEST) {
    state.getLtdUsers = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_LTD_USERS_SUCCESS) {
    state.getLtdUsers = getEndpointStatus('success');
    state.ltdUsers = [...action.payload];

    return { ...state };
  }

  if (action.type === GET_LTD_USERS_FAILURE) {
    state.getLtdUsers = getEndpointStatus('failure');

    return { ...state };
  }

  if (action.type === GET_LTD_USERS_INVOICES_REQUEST) {
    state.getLtdUsersInvoices = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_LTD_USERS_INVOICES_SUCCESS) {
    state.getLtdUsersInvoices = getEndpointStatus('success');
    state.ltdOrders = [...action.payload];

    return { ...state };
  }

  if (action.type === GET_LTD_USERS_INVOICES_FAILURE) {
    state.getLtdUsersInvoices = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function clearUsers() {
  return (dispatch) => {
    dispatch({ type: CLEAR_USERS });
  };
}

export function clearUser() {
  return (dispatch) => {
    dispatch({ type: CLEAR_USER });
  };
}

export function getUsers(params) {
  const request = () => {
    return { type: GET_USERS_REQUEST };
  };
  const success = (res) => {
    return { type: GET_USERS_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: GET_USERS_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getUsers(params);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getMails() {
  const request = () => {
    return { type: GET_MAILS_REQUEST };
  };
  const success = (res) => {
    return { type: GET_MAILS_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: GET_MAILS_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getMails();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getActive() {
  const request = () => {
    return { type: GET_ACTIVE_REQUEST };
  };
  const success = (res) => {
    return { type: GET_ACTIVE_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: GET_ACTIVE_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getActive();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function extendUserTrial(id, data) {
  const request = () => {
    return { type: EXTEND_USER_TRIAL_REQUEST };
  };
  const success = () => {
    return { type: EXTEND_USER_TRIAL_SUCCESS };
  };
  const failure = () => {
    return { type: EXTEND_USER_TRIAL_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.extendUserTrial(id, data);

    if (response && response.status === 200) {
      dispatch(success(response.data));

      return Promise.resolve();
    } else {
      dispatch(failure());

      return Promise.reject();
    }
  };
}

export function updateUser(id, data) {
  const request = () => {
    return { type: UPDATE_USER_REQUEST };
  };
  const success = () => {
    return { type: UPDATE_USER_SUCCESS };
  };
  const failure = () => {
    return { type: UPDATE_USER_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.updateUser(id, data);

    if (response && response.status === 200) {
      dispatch(success(response.data));

      return Promise.resolve();
    } else {
      dispatch(failure());

      return Promise.reject();
    }
  };
}

export function getUser(id) {
  const request = () => {
    return { type: GET_USER_REQUEST };
  };
  const success = (res) => {
    return { type: GET_USER_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: GET_USER_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getUser(id);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getLtdUsers() {
  const request = () => {
    return { type: GET_LTD_USERS_REQUEST };
  };
  const success = (res) => {
    return { type: GET_LTD_USERS_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: GET_LTD_USERS_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getLtdUsers();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getLtdUsersInvoices() {
  const request = () => {
    return { type: GET_LTD_USERS_INVOICES_REQUEST };
  };
  const success = (res) => {
    return { type: GET_LTD_USERS_INVOICES_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: GET_LTD_USERS_INVOICES_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getLtdUsersInvoices();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function deleteUser(id) {
  const request = () => {
    return { type: DELETE_USER_REQUEST };
  };
  const success = (res) => {
    return { type: DELETE_USER_SUCCESS, payload: res };
  };
  const failure = () => {
    return { type: DELETE_USER_FAILURE };
  };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.deleteUser(id);

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function impersonateUser(id, owner) {
  return async () => {
    const response = await services.impersonateUser(id, owner);

    if (response && response.status === 200) {
      return Promise.resolve(response.data._id);
    } else {
      return Promise.reject();
    }
  };
}

export function createMollieOrder(data) {
  return async () => {
    const response = await services.createMollieOrder(data);

    if (response && response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject();
    }
  };
}

export function removeLifeTimeOrder(userId, id) {
  return async () => {
    const response = await services.removeLifeTimeOrder(userId, id);

    if (response && response.status === 200) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject();
    }
  };
}

const services = {
  removeLifeTimeOrder: async (userId, id) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/api/admin/ltd/user/${userId}/order/${id}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  createMollieOrder: async (data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/mollie`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getActive: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/active`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getLtdUsers: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/ltd`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getLtdUsersInvoices: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/ltd/invoices`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getMails: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/mails`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getUsers: async (params) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/users`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        },
        params
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  extendUserTrial: async (id, data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/users/${id}/extendTrial`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getUser: async (id) => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/users/${id}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  deleteUser: async (id) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/api/admin/users/${id}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  updateUser: async (id, data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/users/${id}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  impersonateUser: async (id, owner) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/users/${id}/impersonate`,
        data: { owner },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  }
};
